import { memo } from 'react'

import { PartnerBasicInfo } from 'clickNgo/entities/partner/ui/partnerBasicInfo'

import {
  PARTNER_EDITOR_FORM_KEYS,
  PartnerEditorFormKeys,
  READ_ONLY_BASIC_INFO_FIELDS,
} from '../../../configs'
import { useReadOnlyMenuItem } from '../../../hooks/useReadOnlyMenuItem'
import { PartnerFormEditableContainer } from '../../partnerFormEditableContainer/PartnerFormEditableContainer'

import { useBasicInfoMandatoryAttachments } from './hooks/useBasicInfoMandatoryAttachments'
import { useEditPartnerBasicInfoHandler } from './hooks/useEditPartnerBasicInfoHandler'
import { usePartnerBasicInfoValidation } from './hooks/usePartnerBasicInfoValidation'
import { IWrappedPartnerBasicInfoProps } from './models'

export const WrappedPartnerBasicInfo = memo<IWrappedPartnerBasicInfoProps>(({ partner }) => {
  const { isCurrentMenuItemReadOnly } = useReadOnlyMenuItem()

  const { isAttachmentRequired } = useBasicInfoMandatoryAttachments({
    hasActiveAgreement: partner.hasActiveAgreement,
  })
  const { basicValidationProps } = usePartnerBasicInfoValidation({
    formKeys: PARTNER_EDITOR_FORM_KEYS,
  })

  const { handleOnPartnerBasicChangesApply, handleOnPartnerBasicChangesCancel, errorMessages } =
    useEditPartnerBasicInfoHandler({ partner })

  return (
    <PartnerFormEditableContainer
      partner={partner}
      formKey={PartnerEditorFormKeys.BasicInfo}
      title={PartnerEditorFormKeys.BasicInfo}
      onApply={handleOnPartnerBasicChangesApply}
      onCancel={handleOnPartnerBasicChangesCancel}
      isAttachmentRequired={isAttachmentRequired}
      errorMessages={errorMessages}
      isChangesNeedToBeApproved
    >
      <PartnerBasicInfo
        {...partner}
        {...basicValidationProps}
        isReadOnly={isCurrentMenuItemReadOnly}
        formKeys={PARTNER_EDITOR_FORM_KEYS}
        readOnlyFields={READ_ONLY_BASIC_INFO_FIELDS}
      />
    </PartnerFormEditableContainer>
  )
})
